module.exports = __webpack_public_path__ + "img/55.af9e1963.jpg";